import type { IconData } from '@stacksjs/iconify-core'

export const otherUiColorPalette: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15.324 11.224a8 8 0 1 0-5.257 4.506a4 4 0 0 1 5.257-4.506M9 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0M5.113 6.333a1 1 0 1 0-1.732-1a1 1 0 0 0 1.732 1M3.747 9.301a1 1 0 1 1 1 1.732a1 1 0 0 1-1-1.732m8.872-3.968a1 1 0 1 0-1.732 1a1 1 0 0 0 1.732-1\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiColorPalette
